import http from '@/api/http'
import { PaginatedPayload } from '@/types/Common'

import {
  PostChargingStartPayload,
  PostChargingStartResponse,
  PostChargingStopPayload,
  PostChargingStopResponse,
  GetChargingStatusPayload,
  GetChargingStatusResponse,
  GetChargingHistoryResponse,
  GetChargingConfigResponse,
} from './types'

export const postChargingStart = async (payload: PostChargingStartPayload): Promise<PostChargingStartResponse> => {
  const response = await http.post<PostChargingStartResponse, PostChargingStartPayload>('/charging/start/', payload)
  return response.data
}

export const postChargingStop = async (payload: PostChargingStopPayload): Promise<PostChargingStopResponse> => {
  const { charging_point_id } = payload

  const response = await http.post<PostChargingStopResponse, PostChargingStopPayload>('/charging/stop/', {
    charging_point_id,
  })
  return response.data
}

export const getChargingConfig = async (): Promise<GetChargingConfigResponse> => {
  const response = await http.get<GetChargingConfigResponse>(`/charging/config/`)
  return response.data
}

export const getChargingStatus = async (payload: GetChargingStatusPayload): Promise<GetChargingStatusResponse> => {
  const { charging_point_id } = payload

  const response = await http.get<GetChargingStatusResponse, GetChargingStatusPayload>(
    `/charging/charging-point/${charging_point_id}/status/`
  )
  return response.data
}

export const getChargingHistory = async (payload: PaginatedPayload = {}): Promise<GetChargingHistoryResponse> => {
  const { page, qnt } = payload

  const response = await http.get<GetChargingHistoryResponse, PaginatedPayload>('/charging/history/', {
    page,
    qnt,
  })
  return response.data
}
